module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/$.fails.js
 ** module id = 11
 ** module chunks = 1
 **/